<div class="wrapper" [style]="this.hasResetButton ? 'margin-bottom: 0' : ''">
    <h1 class="header">{{ "SHARED.SELECT_LABEL" | translate }}:</h1>

    <ion-list *ngIf="loading" lines="none">
        <ion-item>
            <ion-label>
                <p>
                    <ion-skeleton-text [animated]="true" style="width: 100%"></ion-skeleton-text>
                </p>
                <p>
                    <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
                </p>
            </ion-label>
        </ion-item>
    </ion-list>

    <ng-container *ngIf="this.multiSelect; else singleSelect">
        <ion-list lines="none">
            <ion-item
                *ngFor="let label of labels"
                [detail]="false"
                (click)="onLabelItemClick(label.id)"
            >
                <ion-checkbox
                    slot="start"
                    label-placement="end"
                    [checked]="isLabelSelected(label.id)"
                    class="label-checkbox"
                >
                    <span class="label-container"
                        ><ion-icon
                            class="label-icon"
                            name="ellipse"
                            [style.color]="label.bgColor"
                        ></ion-icon>
                        <ion-label>{{ label.text }}</ion-label></span
                    ></ion-checkbox
                >
            </ion-item>
        </ion-list>
    </ng-container>
    <ng-template #singleSelect>
        <ion-list lines="none">
            <ion-item
                *ngFor="let label of labels"
                [button]="true"
                [detail]="false"
                (click)="selectLabel(label)"
            >
                <ion-icon
                    class="label-icon"
                    name="ellipse"
                    [style.color]="label.bgColor"
                ></ion-icon>
                <ion-label>{{ label.text }}</ion-label>
            </ion-item>
        </ion-list>
        <ion-button
            (click)="removeSelection()"
            *ngIf="this.hasResetButton"
            class="ion-float-right"
            [strong]="true"
            fill="clear"
            >{{ "OFFERS.CLEAR_FILTER" | translate }}</ion-button
        >
    </ng-template>
</div>
<ion-button class="button-overview" (click)="confirm()" *ngIf="this.multiSelect && !loading">{{
    "SHARED.OK" | translate
}}</ion-button>
